import { render, staticRenderFns } from "./material-rack-edit.vue?vue&type=template&id=282d4d7d&scoped=true"
import script from "./material-rack-edit.vue?vue&type=script&lang=js"
export * from "./material-rack-edit.vue?vue&type=script&lang=js"
import style0 from "./material-rack-edit.vue?vue&type=style&index=0&id=282d4d7d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282d4d7d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('282d4d7d')) {
      api.createRecord('282d4d7d', component.options)
    } else {
      api.reload('282d4d7d', component.options)
    }
    module.hot.accept("./material-rack-edit.vue?vue&type=template&id=282d4d7d&scoped=true", function () {
      api.rerender('282d4d7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/main-data/material-rack/material-rack-edit.vue"
export default component.exports